export default __webpack_public_path__ + "static/fundamentals-1-d811f21b43fed5d2942e5eb4eebad5bc.jpg";